<template>
  <div>
    <a-select
      :disabled="disabled"
      :value="value"
      :allow-clear="true"
      :show-search="true"
      :placeholder="placeholder"
      @change="onChange"
      @clear="onClear"
      option-filter-prop="title"
    >
      <a-select-option v-for="item in dataList" :key="item.id" :value="item.id" :title="item.bizNo">
        {{ item.bizNo }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, computed, watch } from "vue";
import { InvoiceService } from "@/views/contract/invoice/invoice.service";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
import { InvoicePageReq } from "@/views/contract/invoice/invoice.interface";
import { useRoute } from "vue-router";

/**
 * 开票申请单选择器
 */
export default defineComponent({
  name: "InvoiceApplySelect",
  props: {
    placeholder: { type: String, default: "请选择" },
    value: { type: String, default: undefined },
    bizNo: { type: String, default: undefined },
    bizType: { type: String, default: undefined },
    disabled: { type: Boolean, default: false },
    filtersStatus: { type: String, default: "" },
    addRightBizType: {
      type: String,
      default: undefined,
    },
  },
  emits: ["onChange", "update:value"],
  setup(props, { emit }) {
    const { data, run } = InvoiceService.usePageListApi();
    const route = useRoute();
    const onChange = (id) => {
      emit("update:value", id);
      if (!id) {
        // 清除选择时（allow-clear），同步通知父组件
        emit("onChange", "");
        return;
      }
      const { value } = data;
      const newValue = JSON.parse(JSON.stringify(value));
      newValue.forEach((item) => {
        if (item.id === id) {
          emit("onChange", item);
        }
      });
    };

    const onClear = () => {
      emit("update:value", undefined);
      emit("onChange", "");
    };

    const dataList = computed(() => {
      return data.value || [];
    });

    onMountedOrActivated(async () => {
      const req = new InvoicePageReq();
        req.merge({
          current: 1,
          size: 100000,
          applyProcessStatus: "dcl",
          flowStatus: "sptg",
          bizType: props.bizType,
          addRightBizType: props.addRightBizType,
          firstDisplayProjectId: (route["query"]["projectId"] as string),
        });
        await run(req);
    });
    watch(
      () => props.value,
      async () => {      
        if (props.value&&!data.value.some((i: any) => i.id === props.value)) {
          (data.value as any).unshift({
            id: props.value,
            bizNo: props.bizNo,
          });
          // console.log("🚀 ~ file: index.vue:74 ~ data.value:", data.value)
        }
      },{
        immediate:true
      }
    );
    return {
      dataList,
      onChange,
      onClear,
    };
  },
});
</script>
